import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import stripeService from '../services/stripe';

const CheckoutReturnPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) {
      navigate('/account/subscription', { replace: true });
      return;
    }

    const checkStatus = async () => {
      try {
        const { status } = await stripeService.getSessionStatus(sessionId);
        if (status === 'complete') {
          navigate('/account/subscription?success=true', { replace: true });
        } else {
          navigate('/account/subscription', { replace: true });
        }
      } catch (err) {
        setError(
          'We could not confirm your payment status. If you were charged, your license will appear on the subscription page shortly.'
        );
      }
    };

    checkStatus();
  }, [navigate, searchParams]);

  return (
    <div className="flex flex-col flex-1 bg-gray-100 dark:bg-gray-900 color-transition">
      <div className="flex-grow flex items-center justify-center py-20">
        {error ? (
          <div className="text-center max-w-md px-4">
            <p className="text-red-600 dark:text-red-400 mb-4">{error}</p>
            <Link
              to="/account/subscription"
              className="text-sm font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-500"
            >
              Go to subscription page
            </Link>
          </div>
        ) : (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
            <p className="text-gray-600 dark:text-gray-400">Confirming your payment...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutReturnPage;
